module.exports = __webpack_public_path__ + "nf.8b6629d9.svg";